// import { configureStore } from '@reduxjs/toolkit';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import configStore from './store';
import { initializeAppRuntime } from './utils/runtimeInit';
import { installAuthFetchInterceptor } from './utils/httpInterceptor';

const GA_ID = process.env.REACT_APP_GA_ID;

const initAnalytics = () => {
  if (!GA_ID || typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
};

const store = configStore();
const persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById('root'));

const bootLoader = (
  <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
    Loading...
  </div>
);

const renderApp = () => {
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
          <PersistGate loading={bootLoader} persistor={persistor}>
          <App/>
          </PersistGate>
        </Provider>
    //  </React.StrictMode>
  );
};

initializeAppRuntime()
  .catch(() => {
    // no-op: runtime init failures should not block app start
  })
  .finally(() => {
    installAuthFetchInterceptor();
    initAnalytics();
    renderApp();
  });
